<div mat-dialog-content>

  <form #f="ngForm">

    <div>

      <div style="background-color: #F2F3F4;">

        <div class="row" style="margin-left: 3px; margin-right: 3px;">
          
          <div class="col-md-12">
            <div class="form-group">
              <label class="bmd-label-floating"><b>Container Inventory</b> &nbsp;
                <i *ngIf="loadingContainers" class="fa fa-spinner fa-pulse fa-fw"></i>
              </label>
              <app-filter-object
              *ngIf="!loadingContainers"
                [options]="containers"
                (selectChange)="saveContainer($event)"
              ></app-filter-object>
            </div>
          </div>

        </div>

      </div>

    </div>

  </form>

</div>

<div mat-dialog-actions>
  <button mat-button class="btn btn-default" (click)="onCancelClick()">Close</button>
  <!-- <button mat-button [mat-dialog-close]="data.animal" cdkFocusInitial>Ok</button> -->
  <!-- <button mat-button class="btn btn-primary" (click)="onSave()"
          [disabled]="saving || !f.dirty"
          cdkFocusInitial>
    <i *ngIf="saving" class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
    <i *ngIf="!saving" class="fa fa-floppy-o" aria-hidden="true"></i>
    Save
  </button> -->
</div>
